const backendHost = 'https://docgen.svasti.in/docgen/';

export  {backendHost} ;

